var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1114.000000pt",
    height: "194.000000pt",
    viewBox: "0 0 1114.000000 194.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,194.000000) scale(0.100000,-0.100000)",
    fill: "#e10600",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1208 c0 -804 0 -799 61 -919 60 -120 163 -206 306 -256 l78 -28 793 -3 792 -3 0 226 0 225 -685 0 -685 0 0 745 0 745 -330 0 -330 0 0 -732z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2382 973 l3 -968 330 0 330 0 3 968 2 967 -335 0 -335 0 2 -967z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3490 970 l0 -970 270 0 270 0 2 647 3 647 534 -647 534 -647 394 0 393 0 0 970 0 970 -265 0 -265 0 0 -645 c0 -355 -3 -645 -7 -645 -5 1 -246 291 -538 645 l-530 644 -397 0 -398 1 0 -970z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6340 970 l0 -970 1063 2 1062 3 0 220 0 220 -732 3 -733 2 0 155 0 155 705 0 705 0 0 210 0 210 -705 0 -705 0 0 160 0 160 735 0 735 0 0 220 0 220 -1065 0 -1065 0 0 -970z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8760 1720 l0 -220 425 0 425 0 2 -747 3 -748 330 0 330 0 3 748 2 747 425 0 425 0 0 220 0 220 -1185 0 -1185 0 0 -220z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinetLogo);
export default __webpack_public_path__ + "static/media/linet_logo.4168194ce78b14d0e22631705c6a8cef.svg";
export { ForwardRef as ReactComponent };